import { environment } from 'environments/environment';
import { AuthUtils } from 'app/authentication/auth/auth.utils';
import { resolveStoreRoles } from 'app/shared/entitlement/store-access.util';

/**
 * Who may open /admin and see the Administration menu: a superadmin, or an admin of the
 * selected workspace. The stored profile carries no role, so the selected organization and
 * branch role codes are the source of truth. The account-wide flags only count before a
 * workspace is chosen: an admin of one organization is not an admin of another.
 */
export function isWorkspaceAdmin(user: any): boolean {
    if (AuthUtils.isSuperAdminUser(user) || environment.user?.superadmin === true) {
        return true;
    }

    const selection = environment.selection as { organization?: { role_codes?: unknown }; branch?: { role_codes?: unknown } } | undefined;
    if (selection?.organization) {
        const codes = ([] as unknown[])
            .concat(
                Array.isArray(selection.organization.role_codes) ? selection.organization.role_codes : [],
                Array.isArray(selection.branch?.role_codes) ? selection.branch!.role_codes as unknown[] : []
            )
            .map((code) => `${code ?? ''}`.trim().toLowerCase());
        return codes.includes('admin') || codes.includes('superadmin');
    }

    return AuthUtils.hasRole(user?.role, ['@SUPERADMIN', '@ADMIN'], user) || resolveStoreRoles().has('admin');
}
